export default () => ({
	playing: false,

	toggle() {
		if (this.playing) {
			this.$refs.video.pause();
			this.$refs.video.parentNode.classList.add('paused');
		} else {
			this.$refs.video.play();
			this.$refs.video.parentNode.classList.remove('paused');
		}
	},

	onplay() {
		this.playing = true;
		this.$refs.video.parentNode.classList.remove('paused');
	},
	onpause() {
		this.playing = false;
		this.$refs.video.parentNode.classList.add('paused');
	},
});
